export const sentryTrivialErrors = [
  'ResizeObserver loop limit exceeded',
  'ResizeObserver loop completed with undelivered notifications.',
  'Hydration failed because the initial UI does not match what was rendered on the server.',
  'Text content does not match server-rendered HTML.',
  'There was an error while hydrating. Because the error happened outside of a Suspense boundary, the entire root will switch to client rendering.',
];
